// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  passId: __t.u64().primaryKey().name("pass_id"),
  worldId: __t.u64().name("world_id"),
  creator: __t.identity(),
  priceSov: __t.i64().name("price_sov"),
  grants: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
});
